module.exports = __webpack_public_path__ + "assets/b59.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b59.png
// module id = 648
// module chunks = 0